import script from "./DownloadArea.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadArea.vue?vue&type=script&setup=true&lang=js"

import "./DownloadArea.vue?vue&type=style&index=0&id=4680e0ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4680e0ff"]])

export default __exports__